import { Flex } from '@chakra-ui/react';
import React from 'react';

// import IndexingBlocksAlert from './alerts/IndexingBlocksAlert';
import MaintenanceAlert from './alerts/MaintenanceAlert';

const HeaderAlert = () => {
  return (
    <Flex flexDir="column" rowGap={ 3 } mb={ 6 } _empty={{ display: 'none' }}>
      <MaintenanceAlert/>
    </Flex>
  );
};

export default React.memo(HeaderAlert);
